import { type SvgIconProps } from '@common/components/svgs/props';

function IconMail(
  { size = 24, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Mail"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0402 4H6.95984C6.29399 3.99999 5.73444 3.99997 5.27657 4.03738C4.79785 4.0765 4.34289 4.16144 3.91103 4.38148C3.25247 4.71704 2.71704 5.25247 2.38148 5.91103C2.16144 6.34289 2.0765 6.79785 2.03738 7.27657C1.99997 7.73444 1.99999 8.29395 2 8.95981V15.0402C1.99999 15.706 1.99997 16.2656 2.03738 16.7234C2.0765 17.2022 2.16144 17.6571 2.38148 18.089C2.71704 18.7475 3.25247 19.283 3.91103 19.6185C4.34289 19.8386 4.79785 19.9235 5.27657 19.9626C5.73445 20 6.29398 20 6.95987 20H17.0401C17.706 20 18.2656 20 18.7234 19.9626C19.2022 19.9235 19.6571 19.8386 20.089 19.6185C20.7475 19.283 21.283 18.7475 21.6185 18.089C21.8386 17.6571 21.9235 17.2022 21.9626 16.7234C22 16.2656 22 15.7061 22 15.0403V8.95982C22 8.294 22 7.73442 21.9626 7.27657C21.9235 6.79785 21.8386 6.34289 21.6185 5.91103C21.283 5.25247 20.7475 4.71704 20.089 4.38148C19.6571 4.16144 19.2022 4.0765 18.7234 4.03738C18.2656 3.99997 17.706 3.99999 17.0402 4ZM4.81902 6.16349C4.92194 6.11105 5.0844 6.05975 5.43944 6.03074C5.80615 6.00078 6.28343 6 7 6H17C17.7166 6 18.1939 6.00078 18.5606 6.03074C18.9156 6.05975 19.0781 6.11105 19.181 6.16349C19.4203 6.2854 19.6216 6.46887 19.765 6.69386L12.0002 12.7332L4.23514 6.69369C4.37852 6.46878 4.57981 6.28537 4.81902 6.16349ZM4 9.04452V14.5859L7.11701 11.4689L4 9.04452ZM4.81902 17.8365C4.55213 17.7005 4.33243 17.4879 4.18772 17.2266L8.708 12.7063L12.0002 15.2669L15.2922 12.7064L19.8123 17.2265C19.6676 17.4879 19.4479 17.7005 19.181 17.8365C19.0781 17.889 18.9156 17.9403 18.5606 17.9693C18.1939 17.9992 17.7166 18 17 18H7C6.28344 18 5.80615 17.9992 5.43944 17.9693C5.0844 17.9403 4.92194 17.889 4.81902 17.8365ZM20 14.5857V9.04479L16.8832 11.4689L20 14.5857Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconMail.displayName = 'Mail';

export default IconMail;
